import {all, call, takeEvery} from 'redux-saga/effects';

import {sendGoal, sendParams} from 'client/common/utils/metrika';

import * as metrikaActions from 'client/common/store/actions/metrika';

export function* sendGoalsSaga({payload}: metrikaActions.SendGoalsAction) {
    yield all(payload.map(goal => call(sendGoal, goal)));
}

export function* sendParamsSaga({payload: params}: metrikaActions.SendParamsAction) {
    yield call(sendParams, params);
}

export default function* router() {
    yield takeEvery(metrikaActions.SEND_GOALS, sendGoalsSaga);
    yield takeEvery(metrikaActions.SEND_PARAMS, sendParamsSaga);
}
